import { result, chain, isEmpty } from 'underscore';

export class SurveyPreferenceService {
  constructor(props) {
    this.surveyPreferenceKey = 'SurveyPreference';
    this.PreferenceService = result(props, 'PreferenceService');

    this.initializeSurveyPreference();
  }

  initializeSurveyPreference = () => {
    if (isEmpty(this.PreferenceService)) {
      throw new Error('PreferenceService does not exist');
    }

    let surveyPreference = this.getSurveyPreference();
    // initialize survey preference if it does not exist
    if (isEmpty(surveyPreference)) {
      surveyPreference = {
        Name: this.surveyPreferenceKey,
        Data: {},
        Type: 'string',
        Version: 1,
      };
      this.PreferenceService.setAtUserLevel(surveyPreference);
    }
  };

  getDaysAgo = (days) => {
    const now = new Date();
    now.setTime(Date.now() - (86400000 * days));
    return now;
  };

  getDaysAfter = (days, startDate) => {
    const date = startDate ? new Date(startDate) : new Date();
    date.setTime(date.getTime() + (86400000 * days));
    return date;
  };

  getSurveyPreference = () => this.PreferenceService.findByNameAtUserLevel(this.surveyPreferenceKey);
  getAtUserLevel = key => this.PreferenceService.findByNameAtUserLevel(key);

  getSurveyState = ({ surveyName }) => {
    const surveyPreference = this.getSurveyPreference();
    return chain(surveyPreference)
      .result('Data')
      .result(surveyName)
      .value();
  };

  setSurveyState = ({ surveyName, surveyState }) => {
    const surveyPreference = this.getSurveyPreference();
    surveyPreference.Data[surveyName] = surveyState;
    this.PreferenceService.setAtUserLevel(surveyPreference);
  };
}
